import { Component, Input } from "@angular/core";
import { appModuleAnimation } from "@shared/animations/routerTransition";


@Component({
    standalone: false,
    templateUrl: 'help-menu.component.html',
    selector: 'help-menu',
    animations: [appModuleAnimation()]
})
export class HelpMenuComponent {
    @Input() isDropup = false;
    readonly documentationUrl = 'https://docs.intimepro.io/';

    getHelpSection() {
        window.location.href = 'mailto:itpsupport@waiin.com';
    }
}
